function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var LogoFacebookColorSvg = function LogoFacebookColorSvg(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 72 72"
  }, props), React.createElement("rect", {
    fill: "#3d5a98",
    width: 72,
    height: 72,
    rx: 3.97,
    ry: 3.97
  }), React.createElement("path", {
    fill: "#fff",
    d: "M49.68 72V44.12H59l1.4-10.87H49.68v-6.94c0-3.15.87-5.29 5.39-5.29h5.75V11.3a77 77 0 0 0-8.38-.43c-8.3 0-14 5.06-14 14.36v8h-9.37v10.89h9.38V72z"
  }));
};

LogoFacebookColorSvg.displayName = "LogoFacebookColorSvg";
export default LogoFacebookColorSvg;